/*export const searchColumns = () => {
  return [
    {
      name: '导入批次号',
      prop: 'importBatchNo',
      type: 'input',
    },
    {
      name: '创建人',
      prop: 'reportedBy',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
    },

    /!*{
      name: '公司名称',
      prop: 'enterpriseName',
      type: 'input',
    },*!/

    {
      prop: 'enterpriseName',
      name: '公司名称',
      type: 'select',
      options: this.newCompanyList,
      value: 'dataCode',
      label: 'dataName',
      changeMethod: this.newChangeCompanyHandler,
    },

    {
      name: '报表时间',
      prop: 'gmtCreate',
      type: 'date',
    },
    {
      name: '统计报表',
      prop: 'businessType',
      type: 'select',
      options: [
        { label: '中转物资', value: '中转物资' },
        { label: '资产出租', value: '资产出租' },
        { label: '商品购销存数量', value: '商品购销存数量' },
        { label: '商品购销存总额', value: '商品购销存总额' },
        { label: '盈利报表', value: '盈利报表' },
      ],
    },
    {
      name: '单据状态',
      prop: 'status',
      type: 'select',
      options: [
        { label: '草稿中', value: '草稿中' },
        { label: '审批中', value: '审批中' },
        { label: '已通过', value: '已通过' },
        { label: '已驳回', value: '已驳回' },
      ],
    },
  ];
};*/

// 默认表头
export const defaultTableColumn = () => [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'importBatchNo',
    title: '导入批次号',
    visible: true,
  },
  {
    field: 'businessType',
    title: '业务类型',
    visible: true,
  },
  {
    field: 'reportedBy',
    title: '创建人',
    visible: true,
  },
  {
    field: 'enterpriseName',
    title: '公司名称',
    visible: true,
  },
  {
    field: 'dataMonth',
    title: '填报年月',
    visible: true,
  },
  {
    field: 'gmtCreate',
    title: '创建时间',
    visible: true,
  },
  {
    field: 'gmtModified',
    title: '提交时间',
    visible: true,
  },
  {
    field: 'status',
    title: '状态',
    visible: true,
  },
  {
    field: 'remark',
    title: '备注',
    visible: true,
  },
];

// 默认显示的按钮
export const defaultMenuBtnList = [
  {
    id: 1,
    label: '资产出租',
    type: '0',
    attributes: {
      buttonUrl: 'leasingAssetsTuationImportExcel',
    },
  },
  {
    id: 2,
    label: '商品购、销、存数量',
    type: '0',
    attributes: {
      buttonUrl: 'productionInformationNumberImportExcel',
    },
  },
  {
    id: 3,
    label: '商品购、销、存总额',
    type: '0',
    attributes: {
      buttonUrl: 'productionInformationTotalAmountImportExcel',
    },
  },
  {
    id: 4,
    label: '盈利报表',
    type: '0',
    attributes: {
      buttonUrl: 'profitStatementImportExcel',
    },
  },
  {
    id: 5,
    label: '中转物资',
    type: '0',
    attributes: {
      buttonUrl: 'transitMaterialsStatisticsImportExcel',
    },
  },
  {
    id: 6,
    label: '下载模板',
    type: '0',
    attributes: {
      buttonUrl: 'downloadFilesTemplate',
    },
  },
  {
    id: 7,
    label: '删除',
    type: '0',
    attributes: {
      buttonUrl: 'deleteDraftExcel',
    },
  },
];

import BASE_API from '@/api/dataBase';
import API from '@/api/dataBase';
import dictAPI from '@/api/systemManage/dict.js';

export default {
  data() {
    return {
      companyList: [],
      departmentList: [],
      newCompanyList: [],
    };
  },
  methods: {
    // 下载文件模板
    downloadBtnClickHandler() {
      let params = {
        keyList: ['scm/maindata/导入模板2024070317344534850.xlsx'],
      };
      this.$axios.post(API.DOWNLOAD_FILE, params).then((res) => {
        if (res.data.code == 0) {
          res.data.data.map((it) => {
            setTimeout(() => {
              this.downloadFile(it);
            }, 100);
          });
        }
      });
    },
    searchColumns() {
      return [
        {
          name: '导入批次号',
          prop: 'importBatchNo',
          type: 'input',
        },
        {
          name: '创建人',
          prop: 'reportedBy',
          type: 'searchTableSpec',
          searchType: 'personnel',
          isMultiple: true,
        },
        {
          prop: 'enterpriseName',
          name: '公司名称',
          type: 'select',
          options: this.newCompanyList,
          value: 'dataCode',
          label: 'dataName',
          changeMethod: this.newChangeCompanyHandler,
        },
        {
          name: '填报年月',
          prop: 'dataMonth',
          type: 'month',
          format: 'yyyy-MM',
          changeMethod: 'changeDataMonthHandler',
        },
        {
          name: '统计报表',
          prop: 'businessType',
          type: 'select',
          options: [
            { label: '中转物资', value: '中转物资' },
            { label: '资产出租', value: '资产出租' },
            { label: '商品购销存数量', value: '商品购销存数量' },
            { label: '商品购销存总额', value: '商品购销存总额' },
            { label: '盈利报表', value: '盈利报表' },
          ],
        },
        {
          name: '单据状态',
          prop: 'status',
          type: 'select',
          options: [
            { label: '草稿中', value: '草稿中' },
            { label: '审批中', value: '审批中' },
            { label: '已通过', value: '已通过' },
            { label: '已驳回', value: '已驳回' },
          ],
        },
      ];
    },

    //多个文件下载
    downloadFile(url) {
      window.open(url, '_blank');
    },
    // 年月
    changeDataMonthHandler(val) {
      console.log(val, '日期');
      this.$emit('changeDataMonthHandler', val);
    },
    // 切换公司
    newChangeCompanyHandler(val) {
      console.log(val, '切换公司js');
      const item = this.newCompanyList.find((item) => item.dataCode == val);
      this.query = {
        ...this.query,
        enterpriseName: item.dataName,
      };
      /*this.baseFormData = {
        ...this.baseFormData,
        enterpriseName: item.dataName,
        companyCode: val,
        companyName: item.dataName,
      };*/
    },
    //获取字典公司数据
    async getListData() {
      await this.$axios
        .post(dictAPI.DICT_DATA_DICT_API, {
          // 生产环境dictCode 202407031048117299035
          dictCode: '202406211727166954331',
          dataStatus: 0,
          pageNum: 1,
          pageSize: 100,
        })
        .then((res) => {
          if (0 == res.data.code) {
            this.newCompanyList = res.data.data.list;
            console.log('this.newCompanyList', this.newCompanyList);
            if (
              ['edit', 'detail'].includes(this.$route.query?.status) ||
              (['create'].includes(this.$route.query?.status) && this.$route.query?.id?.length > 0)
            ) {
              console.log('编辑');
            }
          } else {
            this.$alert(res.data.msg);
          }
        });
    },

    // 获取公司
    async _getCompanyApi() {
      console.log('开始获取公司', this.userInfo);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        console.log(data.data, '???=====》》');
        this.companyList = data.data?.personCompanyInfo;
        console.log(this.companyList, 'companyList');
        console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');
        setTimeout(() => {
          this.getTableData();
        }, 10);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
      console.log(companyCode, isFirst);
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: companyCode,
      });
      if (data.code == 0) {
        console.log(data.data, '部门信息');
        this.departmentList = data.data?.personDepartmentInfo;
      } else {
        console.error('获取部门失败');
      }
    },
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      console.log(item, '切换公司item');
      this.query = {
        ...this.query,
        settlementDepartmentNo: '',
        settlementCompanyNo: val,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      console.log(this.departmentList, 'this.departmentList');
      this.query = {
        ...this.query,
        settlementDepartmentNo: val,
      };
    },
    // 切换结算中心
    changeSettlementCenterHandler(val) {
      console.log(val, '切换结算中心');
      this.query = {
        ...this.query,
        settlementCenter: val,
      };
    },
  },

  mounted() {
    // this.getCompanyApi();
    this.$nextTick(() => {
      // this._getCompanyApi();
      this.getListData();
    });
  },
};
